import React from 'react';
import moment from 'moment-timezone';
import { WarningOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { Wrapper, FilterCreation, FilterName } from './styled';
import EarlierOrder from '@src/pages/Precision/PrecisionPolicy/components/Policies/EarlierOrder';
import EditFilterButton from '@src/pages/Precision/PrecisionPolicy/components/Policies/EditFilterButton';

const fmt = 'HH:mm:ss, MMM DD YYYY';

interface IPolicy {
  filter_name: string;
  filter_created: Date;
  filter_updated: Date;
  filter_text: string;
}

interface IProps {
  policy: IPolicy;
  index: number;
  rowIndex: number;
  sortable: boolean;
  idx: number;
  order: Array<number>;
  originalOrder: Array<number>;
}

const PolicyFilter: React.FC<IProps> = ({
  policy,
  index,
  rowIndex,
  sortable,
  order,
  originalOrder,
}) => (
  <Wrapper>
    <div style={{ display: 'flex' }}>
      <EarlierOrder policy={policy} idx={rowIndex} order={order} originalOrder={originalOrder} />
      <FilterName title={policy.filter_text} placement="bottomLeft">
        {policy.filter_name}
      </FilterName>
    </div>
    <FilterCreation className="filter-creation">
      Filter updated at {moment(policy.filter_updated).format(fmt)}{' '}
      {!sortable && index !== rowIndex && (
        <Tooltip title="Policy Rank not matching with Filter Sequence. Reorder Policies to fix the issue or reach out to support.">
          <WarningOutlined style={{ color: '#faad14', fontSize: 18 }} />
        </Tooltip>
      )}
      <EditFilterButton policy={policy} />
    </FilterCreation>
  </Wrapper>
);

export default PolicyFilter;
